"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditProposal = void 0;
const react_1 = require("@apollo/client/react");
const edit_proposal_mutation_1 = require("../edit-proposal.mutation");
const useEditProposal = () => {
    const [editProposal, data] = (0, react_1.useMutation)(edit_proposal_mutation_1.EDIT_PROPOSAL);
    return Object.assign({ editProposal }, data);
};
exports.useEditProposal = useEditProposal;
exports.default = exports.useEditProposal;
